import { Card, Checkbox, Stack, Text } from "@mantine/core"

type ConsentStepProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
};

export const ConsentStep: React.FC<ConsentStepProps> = ({ checked, onChange }) => {

    return (
        <Stack w={700}>
            <Card
                withBorder
            >
                <Stack gap="xl">
                    <Text maw={900}>
                    In order to capture and showcase life at Godalming College, we often take photographs and video footage around campus, at College events and, occasionally, in lessons. These images may be used for marketing and communication purposes, for example on the College website, social media channels and other College materials.<br/><br/>
                    It is not always possible for us to ask every individual in a group or crowd for permission before a photograph or video is taken. As part of the College community, you may therefore be included in photographs or video footage where you are part of a group or crowd and are not the main focus of the image.<br/><br/>
                    If a photograph or video is being taken where you are the focus of the image, the College will ask for your permission at the time.<br/><br/>
                    If you see photographs or video footage being taken and do not wish to be included, please make this known to the photographer or move out of shot where possible.<br/><br/>
                    If you do not wish your image to be used in College photographs or video footage for marketing and communication purposes, please email marketing@godalming.ac.uk. You can update your preferences at any time, but it may not be possible to withdraw images that have already been published before your request is received.
                    </Text>
                </Stack>
            </Card>
        </Stack>
    )
}
